import http from '../../utils/fetch';
import updownfile from "../../utils/updownfile";
import request from "../../utils/request";

export default {
  baseurl: '/api/swyl/v1/dingdmain',


  //更改附件上传状态
  updateFjStatus (sapCode) {
    return http({
      url: this.baseurl + '/updateFjStatus',
      method: 'post',
      params: { sapCode, }
    });
  },

  //更改多个附件上传状态
  updateFjStatusA (sapCode) {
    return http({
      url: this.baseurl + '/updateFjStatusA',
      method: 'post',
      params: { sapCode, }
    });
  },

  //更新上传开票附件状态
  updateKpStatus (sapCodes) {
    return http.post(this.baseurl + '/updateFpStatus', sapCodes);
  },
  //更新上传开票附件状态
  DingdToSap (sapCodes) {
    return http.post(this.baseurl + '/DingdToSap', sapCodes);
  },
  //海外标准订单签收
  DingdUsaQs (sapCodes) {
    return http.post(this.baseurl + '/DingdUsaQs', sapCodes);
  },
  //判断订单是否上传开票附件
  getKpStatus (sapCode) {
    return http({
      url: this.baseurl + '/getKpStatus',
      method: 'post',
      params: { sapCode, }
    });
  },
  //判断内销订单是否上传开票附件
  getNxFjStatus (sapCode) {
    return http({
      url: this.baseurl + '/getNxFjStatus',
      method: 'post',
      params: { sapCode, }
    });
  },

  //增添报关单号和提单号
  updateByModel (query) {
    return http({
      url: this.baseurl + '/updateByModel',
      method: 'post',
      params: query
    });
  },

  //增添多个报关单号
  updateByModelA (query) {
    return http({
      url: this.baseurl + '/updateByModelA',
      method: 'post',
      params: query
    });
  },

  //增添多个提单号
  updateByModelB (query) {
    return http({
      url: this.baseurl + '/updateByModelB',
      method: 'post',
      params: query
    });
  },

  //增添多个结算发票号
  updateByModelE (query) {
    return http({
      url: this.baseurl + '/updateByModelE',
      method: 'post',
      params: query
    });
  },

  //批量开票
  makeInvoiceAll (sapId) {
    return http({
      url: '/api/swyl/v1/demo/viewOrder/makeInvoice',
      method: 'post',
      params: { sapId }
    });
  },

  //合单相关数据录入
  updateByModelW (query) {
    return http({
      url: this.baseurl + '/updateByModelW',
      method: 'post',
      params: query
    });
  },

  //修改装箱方式
  updateByModelBox (query) {
    return http({
      url: this.baseurl + '/updateByModelBox',
      method: 'post',
      params: query
    });
  },

  //获取物流天数
  getSendDays (qucode) {
    return http({
      url: this.baseurl + '/getSendDays',
      method: 'post',
      params: { qucode }
    });
  },
  //分页查询订单
  orderProcessPage (query) {
    return http({
      url: '/api/swyl/v1/viewOrderProcess/orderProcessPage',
      method: 'post',
      params: query
    });
  },
  createInvoice (data) {
    return http({
      url: '/api/swyl/v1/viewOrderProcess/createInvoice',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  },
  createInvoicePdf (data) {
    return http({
      url: '/api/swyl/v1/viewOrderProcess/createInvoicePdf',
      method: 'post',
      data: data,
      responseType: 'arraybuffer',
    });
  },
  //发货单打印
  getFhdPrintPdf (orderNum) {
    return http({
      url: '/api/swyl/v1/viewOrderProcess/getFhdPrintPdf?orderNum=' + orderNum,
      method: 'get',
    });
  },

  //打印箱单发票
  printInvoice (sapId) {
    return http({
      url: this.baseurl + '/printInvoice',
      method: 'post',
      params: { sapId }
    });
  },
  //开票
  makeInvoice (sapId) {
    return http({
      url: this.baseurl + '/makeInvoice',
      method: 'post',
      params: { sapId }
    });
  },
  //冲销
  writeOff (sapId) {
    return http({
      url: this.baseurl + '/writeOff',
      method: 'post',
      params: { sapId }
    });
  },
  //确认发货
  confirmSend (sapCode) {
    return http({
      url: '/api/swyl/v1/dingdmainsend/confirmSend',
      method: 'post',
      params: { sapCode }
    });
  },
  confirmSendNew (sapCode) {
    return http({
      url: '/api/swyl/v1/dingdmainsend/confirmSendNew',
      method: 'post',
      params: { sapCode }
    });
  },
  //批量发货
  confirmSendAll (sapCodes) {
    return http.post('/api/swyl/v1/dingdmainsend/confirmSendAll', sapCodes);
  },
  //解冻开票
  updateBillBlk (sapCodes) {
    return http.post('/api/swyl/v1/dingdmainsend/updateBillBlk', sapCodes);
  },
  //分页查询库存详情订单
  selectStockPage (query) {
    return http({
      url: '/api/swyl/v1/dingdmainsend/selectStockPage',
      method: 'post',
      params: query
    });
  },
  //分页查询订单
  selectPage (query) {
    return http({
      url: this.baseurl + '/searchOrderPage',
      method: 'post',
      params: query
    });
  },
  //分页查询订单
  selectDingdanPage (query) {
    return http({
      url: '/api/swyl/v1/demo/viewOrder/selectPage',
      method: 'post',
      params: query
    });
  },
  associationOrderPage (query) {
    return http({
      url: '/api/swyl/v1/demo/bscDemo/associationOrderPage',
      method: 'post',
      params: query
    });
  },
  supplementlater (data) {
    return http({
      responseType: 'arraybuffer',
      url: '/api/swyl/v1/dingdmain/supplementlater',
      method: 'post',
      data: data
    });
  },
  selectClaimYuanxiPage(data) {
    return http({
      url: '/api/swyl/v1/bscClaimRecordYuanxi/selectClaimYuanxiPage',
      method: 'post',
      params: data
    });
  },
  selectList(data) {
    return http({
      url: '/api/swyl/v1/bscClaimRecordYuanxi/selectList',
      method: 'post',
      data: data
    });
  },
  saveClaimRecordYuanxi(data,param) {
    return http({
      url: '/api/swyl/v1/bscClaimRecordYuanxi/saveClaimRecordYuanxi?contractNo=' + param,
      method: 'post',
      data: data
    });
  },
  changeClaimAmount(data) {
    return http({
      url: '/api/swyl/v1/bscClaimRecordYuanxi/changeClaimAmount',
      method: 'post',
      data: data
    });
  },
  pushSapData(data) {
    return http({
      url: '/api/swyl/v1/bscClaimRecordYuanxi/pushSapData',
      method: 'post',
      data: data
    });
  },
  supplementlaterChange (data) {
    return http({
      url: '/api/swyl/v1/dingdmain/supplementlaterChange',
      method: 'post',
      data: data
    });
  },
  testprintDispatchBill (query) {
    return http({
      responseType: 'arraybuffer',
      url: '/api/swyl/v1/demo/bscAccompanyingInstruction/testprintDispatchBill',
      method: 'post',
      params: query
    });
  },
  //分页查询订单美国医疗
  selectUsaPage (query) {
    return http({
      url: '/api/swyl/v1/demo/viewOrder/selectUsaPage',
      method: 'post',
      params: query
    });
  },
  downloadZip (query) {
    return http({
      url: '/api/swyl/v1/demo/viewOrder/downZip',
      method: 'post',
      data: query,
      responseType: 'blob',
    });
  },
  //分页查询订单
  selectFhPage (query) {
    return http({
      url: '/api/swyl/v1/dingdmain/shipmentSchedule/selectList',
      method: 'post',
      params: query
    });
  },
  selectRecordPage (data) {
    return http({
      url: '/api/swyl/v1/sendGoodsRecord/selectRecordPage',
      method: 'post',
      params: data
    });
  },
  exportRecord (query) {
    return http({
      url: '/api/swyl/v1/sendGoodsRecord/exportRecord',
      method: 'post',
      data: query,
      responseType: 'blob',
    });
  },
  //用车
  selectCarList (query) {
    return http({
      url: '/api/swyl/v1/dingdmain/shipmentSchedule/selectCarList',
      method: 'post',
      data: query
    });
  },
  downloadExcel (query) {
    return http({
      url: '/api/swyl/v1/dingdmain/shipmentSchedule/downloadExcel',
      method: 'post',
      data: query,
      responseType: 'blob',
    });
  },
  downloadBatchExcel (query) {
    return http({
      url: '/api/swyl/v1/dingdmain/shipmentSchedule/downloadOrderExcel',
      method: 'post',
      data: query,
      responseType: 'blob',
    });
  },
  downloadCarExcel (query) {
    return http({
      url: '/api/swyl/v1/dingdmain/carApplication/downloadExcel?ycid=' + query.id,
      method: 'post',
      responseType: 'blob',
    });
  },
  //分页查询订单
  selectCarPage (query) {
    return http({
      url: '/api/swyl/v1/dingdmain/carApplication/selectList',
      method: 'post',
      params: query
    });
  },
  //更新收货时间标志
  updateShouhuoflag (orderids) {
    return http({
      url: this.baseurl + '/updateShouhuoflag',
      method: 'post',
      params: { orderids }
    });
  },
  //选择项目
  projectManageList (query) {
    return http({
      url: '/api/swyl/v1/xiangmu/proMain/projectManageList',
      method: 'post',
      params: query
    });
  },
  initOrder (form) {
    return http.post('/api/swyl/v1/dingdmain/initOrder', form);
  },
  selectById (id, taskid) {
    return http({
      url: '/api/swyl/v1/dingdmain/selectById',
      method: 'post',
      params: { id, taskid }
    });
  },
  selectByIdUsa (id, taskid) {
    return http({
      url: '/api/swyl/v1/dingdmain/selectByIdUsa',
      method: 'post',
      params: { id, taskid }
    });
  },
  selectZlById (id) {
    return http({
      url: '/api/swyl/v1/dingdmainZl/selectById',
      method: 'post',
      params: { id }
    });
  },
  selectByIdCd (id) {
    return http({
      url: '/api/swyl/v1/dingdmain/sapOrderSelect',
      method: 'post',
      params: { id }
    });
  },
  //获取汇率
  getExchange (param) {
    return http({
      url: '/api/swyl/v1/bsc/orderExchange/getExchange',
      method: 'post',
      params: param
    });
  },
  //手动获取汇率
  getExchangeFromSap (param) {
    return http({
      url: '/api/swyl/v1/bsc/orderExchange/getExchangeFromSap',
      method: 'post',
      params: param
    });
  },

  //获取sap三大定价
  getSdPriceFromSap (param) {
    return http({
      url: '/api/swyl/v1/price/mdmMaterialInfoPrice/getSdPriceFromSap',
      method: 'post',
      params: param
    });
  },

  //作废订单
  sapDeleteOrder (id, deleteReason) {
    return http({
      url: this.baseurl + '/sapDeleteOrder',
      method: 'post',
      params: { id, deleteReason }
    });
  },
  //修改业绩归属日期
  updateBusinessDate (sapCodes, businessDate) {
    return http({
      url: '/api/swyl/v1/product/updateBusinessDate',
      method: 'post',
      params: { sapCodes, businessDate }
    });
  },
  //作废订单
  sapDeleteOrderSh (id, deleteReason) {
    return http({
      url: this.baseurl + '/sapDeleteOrderSh',
      method: 'post',
      params: { id, deleteReason }
    });
  },
  //删除订单
  sapDeleteOrder2 (id, deleteReason) {
    return http({
      url: this.baseurl + '/sapDeleteOrder2',
      method: 'post',
      params: { id, deleteReason }
    });
  },
  //删除订单
  sapDeleteOrderSh2 (id, deleteReason) {
    return http({
      url: this.baseurl + '/sapDeleteOrderSh2',
      method: 'post',
      params: { id, deleteReason }
    });
  },
  //撤回订单
  sapCHOrder (id, deleteReason, type, status) {
    return http({
      url: this.baseurl + '/sapWithdrawOrder',
      method: 'post',
      params: { id, deleteReason, type, status }
    });
  },
  //判断上传凭证附件是否都上传B
  isList (reftype, refid, flag) {
    return http({
      url: '/api/file/fileopt/isList',
      method: 'post',
      params: { reftype, refid, flag }
    });
  },
  //撤回订单
  sapCHOrderSh (id, deleteReason, type) {
    return http({
      url: this.baseurl + '/sapWithdrawOrderSh',
      method: 'post',
      params: { id, deleteReason, type }
    });
  },
  //申请作废订单
  shenqingzuofei (id, deleteReason) {
    return http({
      url: this.baseurl + '/shenqingzuofei',
      method: 'post',
      params: { id, deleteReason }
    });
  },
  yunwei () {
    return http({
      url: this.baseurl + '/yunwei',
      method: 'post',
      params: {}
    });
  },

  //得到用户的所有的信贷
  getUserMoneyCredit (params) {
    return http({
      url: '/api/swyl/v1/dingdmaincredit/getUserMoneyCredit',
      method: 'post',
      params: params
    });
  },
  //保存，或者提交
  saveOrSubmit (data) {
    return http({
      url: '/api/swyl/v1/dingdmain/saveOrSubmit',
      method: 'post',
      data: data
    });
  },
  //保存，或者提交
  saveOrSubmitUsa (data) {
    return http({
      url: '/api/swyl/v1/dingdmain/saveOrSubmitUsa',
      method: 'post',
      data: data
    });
  },
  addShipmentSchedule (data) {
    return http({
      url: '/api/swyl/v1/dingdmain/shipmentSchedule/addShipmentSchedule',
      method: 'post',
      data: data
    });
  },
  updateShipmentSchedule (data) {
    return http({
      url: '/api/swyl/v1/dingdmain/shipmentSchedule/updateShipmentSchedule',
      method: 'post',
      data: data
    });
  },
  delShipmentSchedule (id) {
    return http({
      url: '/api/swyl/v1/dingdmain/shipmentSchedule/delShipmentSchedule?id=' + id,
      method: 'get',
    });
  },
  addCarApplication (data) {
    return http({
      url: '/api/swyl/v1/dingdmain/carApplication/addCarApplication',
      method: 'post',
      data: data
    });
  },
  updateCarApplication (data) {
    return http({
      url: '/api/swyl/v1/dingdmain/carApplication/updateCarApplication',
      method: 'post',
      data: data
    });
  },
  delCarApplication (id) {
    return http({
      url: '/api/swyl/v1/dingdmain/carApplication/delCarApplication?id=' + id,
      method: 'get',
    });
  },
  //9390或9370卖给6200保存，或者提交
  saveOrSubmitToHaiWai (data) {
    return http({
      url: '/api/swyl/v1/dingdmain/saveOrSubmitToHaiWai',
      method: 'post',
      data: data
    });
  },
  //保存，或者提交
  shpsaveOrSubmit (params) {
    return http({
      url: '/api/swyl/v1/dingdmain/shpsaveOrSubmit',
      method: 'post',
      data: params
    });
  },
  //修改sap价格
  saveOrderPriceChange (params) {
    return http({
      url: '/api/swyl/v1/dingdmain/saveOrderPriceChange',
      method: 'post',
      data: params
    });
  },
  //保存，或者提交 美国医疗外销标准订单
  shpsaveOrSubmitUsa (params) {
    return http({
      url: '/api/swyl/v1/dingdmain/shpsaveOrSubmitUsa',
      method: 'post',
      data: params
    });
  },
  //手动推送Sap
  submitOrderSap (params) {
    return http({
      url: '/api/swyl/v1/dingdmain/submitOrderSap',
      method: 'post',
      data: params
    });
  },
  //手动推送Sap
  submitOrderSapOld (params) {
    return http({
      url: '/api/swyl/v1/dingdmain/submitOrderSapOld',
      method: 'post',
      data: params
    });
  },
  //手动推送Sap
  submitOrderSapPass (params) {
    return http({
      url: '/api/swyl/v1/dingdmain/submitOrderSapPass',
      method: 'post',
      data: params
    });
  },
  //手动推送Sap元析外销组合订单
  submitOrderSapPassYxZh (params) {
    return http({
      url: '/api/swyl/v1/dingdmain/submitOrderSapPassYxZh',
      method: 'post',
      data: params
    });
  },
  //手动推送Sap
  submitOrderSapPassHhnx (params) {
    return http({
      url: '/api/swyl/v1/dingdmain/submitOrderSapPassHhnx',
      method: 'post',
      data: params
    });
  },
  //液氮罐。。。保存，或者提交
  ydgshpsaveOrSubmit (params) {
    return http({
      url: '/api/swyl/v1/ydgdingdmain/shpsaveOrSubmit',
      method: 'post',
      data: params
    });
  },
  //批量审批
  allSP (params) {
    return http({
      url: '/api/swyl/v1/dingdmain/allSP',
      method: 'post',
      data: params
    });
  },
  createHTXS (params) {
    return http({
      url: '/api/swyl/v1/hetong/bscContract/createHTXS',
      method: 'post',
      data: params
    });
  },
  createTCHTXS (params) {
    return http({
      url: '/api/swyl/v1/hetong/bscContract/createTCHTXS',
      method: 'post',
      data: params
    });
  },
  //查询成本中心
  getCostCenterList (params) {
    return http({
      url: '/api/swyl/v1/dingdmain/orderCostCenter/selectList',
      method: 'post',
      params: params
    });
  },
  //有国家大区的送达方f
  showQycountry () {
    return http({
      url: '/api/swyl/v1/dingdmain/showQycountry',
      method: 'post',
    });
  },
  getQycountry (params) {
    return http({
      url: '/api/swyl/v1/bscDeliveryAreaCountry/getQycountry',
      method: 'post',
      data: params
    });
  },
  getBusinessOwnerList (params) {
    return http({
      url: '/api/swyl/v1/bscDeliveryAreaCountry/getBusinessOwnerList',
      method: 'post',
      data: params
    });
  },
  //用车申请查看
  carQycountry (id) {
    return http({
      url: '/api/swyl/v1/dingdmain/carApplication/selectInfoById?id=' + id,
      method: 'post',
    });
  },
  createShipmentNum () {
    return http({
      url: '/api/swyl/v1/dingdmain/shipmentSchedule/createShipmentNum',
      method: 'post',
    });
  },
  selectShipmentInfo (id) {
    return http({
      url: '/api/swyl/v1/dingdmain/shipmentSchedule/selectShipmentInfo?id=' + id,
      method: 'post',
    });
  },
  getAreaList (code) {
    return http({
      url: '/api/swyl/v1/dingdmain/getAreaList?code=' + code,
      method: 'post',
    });
  },
  getAreaUserList (code) {
    return http({
      url: '/api/swyl/v1/dingdmain/getAreaUserList?code=' + code,
      method: 'post',
    });
  },
  //获取定制list
  listDingzhi (params) {
    return http({
      url: '/api/swyl/v1/orderMainGaizhi/selectList',
      method: 'post',
      params: params
    });
  },
  //获取定制list
  getselectedDingzhides (params) {
    return http({
      url: '/api/swyl/v1/orderMainGaizhi/getselectedDingzhides',
      method: 'post',
      params: params
    });
  },
  //免费订单查询成本价
  getCostPrice (query) {
    return http.post('/api/swyl/v1/chengben/sapZsdSwylCb/getSapByChengben', query);
  },

  //获取所属大区列表
  getDq () {
    return http({
      url: '/api/swyl/v1/dingdmain/getDq',
      method: 'post',
    });
  },

  //获取国家列表
  getGj (query) {
    return http({
      url: '/api/swyl/v1/dingdmain/getGj?dqcode=' + query,
      method: 'post',
      params: query
    });
  },

  //信贷标识传递SAP
  submitCreditFlag (query) {
    return http({
      url: '/api/swyl/v1/dingdmain/submitCreditFlag',
      method: 'post',
      params: query
    });
  },
  // 查询四张产品比对视图
  selectListinfo (query) {
    return http({
      url: '/api/swyl/v1/demo/viewOrderFourview/selectList',
      method: 'post',
      data: query
    });
  },
  //附件上傳校驗
  uploadCheck (data) {
    return http({
      url: '/api/swyl/v1/order/bscOrderProductDeliveryday/checkProductCode',
      method: 'post',
      data: data
    });
  },
  //收货日期校验
  checkDeliveryDay (data) {
    return http({
      url: '/api/swyl/v1/order/bscOrderProductDeliveryday/checkDeliveryDay',
      method: 'post',
      data: data
    });
  },
  //分页查询订单
  orderKaipioaPage (query) {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/selectPage',
      method: 'post',
      params: query
    });
  },
  //更新上传开票附件状态
  updateLkStatus (data) {
    return http.post('/api/swyl/v1/demo/orderNxKaipiao/updateLkStatus?sapCode=' + data);
  },
  selectByCode (data) {
    return http.post('/api/swyl/v1/demo/bscContractHhxm/selectByCode?sapCode=' + data);
  },
  updateById (params) {
    return http({
      url: '/api/swyl/v1/demo/bscContractHhxm/updateById',
      method: 'post',
      data: params
    });
  },
  //获取国家列表
  /*    getGj(query){
          return http({
              url: '/api/swyl/v1/dingdmain/getGj?dqcode='+query,
              method: 'post',
              params: query
          });
      },*/
  //解冻开票
  sendTosapKaipiao (ids) {
    return http.post('/api/swyl/v1/demo/orderNxKaipiao/sendTosapKaipiao', ids);
  },

  //冷库自动化签收 提交
  submitLKKaipiao (ids) {
    return http.post('/api/swyl/v1/demo/orderNxKaipiao/submitLKKaipiao', ids);
  },
  //冷库自动化签收 审批
  approveLKKaipiao (data) {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/approveLKKaipiao',
      method: 'post',
      params: data,
    });
  },
  //根据id获取开票信息
  getKaipiaoById (id) {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/getKaipiaoById',
      method: 'post',
      params: { id: id }
    });
  },

  //获取所属大区列表
  isDate () {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/isDate',
      method: 'post',
    });
  },
  isDateTc () {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/isDateTc',
      method: 'post',
    });
  },
  //获取所属大区列表
  getLastEndTime (data) {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/getLastEndTime',
      method: 'post',
      params: data,
    });
  },
  //保存禁止签收时间
  saveEndTime (query) {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/saveEndTime',
      method: 'post',
      params: query
    });
  },
  //维护不可签收时间并记录修改信息
  saveEndTimeMaintain (query) {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/saveEndTimeMaintain',
      method: 'post',
      params: query
    });
  },
  //分页查询维护不可签收时间修改记录
  selectEndTimeLogPage (data) {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/selectEndTimeLogPage',
      method: 'post',
      params: data
    });
  },
  //判断是否海尔标准配置
  checkStandard (query) {
    return http.post('/api/swyl/v1/dingdmain/checkStandard?sapCode=' + query);
  },
  //获取订单id
  getOrderId (query) {
    return http.post('/api/swyl/v1/dingdmain/getOrderId?id=' + query);
  },
  //获取销售订单成交价
  getOrderFinalPriceBySapcode(query) {
      return http.post('/api/swyl/v1/dingdmain/getOrderFinalPriceBySapcode?orderId='+query);
  },
  //分页查询订单
  confirmPackageAccept (query) {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/confirmPackageAccept',
      method: 'post',
      params: query
    });
  },
  //获取套餐详情
  getPackageInfo (data) {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/getPackageDetail',
      method: 'post',
      params: data
    });
  },
  //套餐批量解冻开票
  tcSendToSapQs (list) {
    return http.post('/api/swyl/v1/demo/orderNxKaipiao/sendToSapPackage', list);
  },
  //获取套餐详情
  tcInvoice (data) {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/tcInvoice',
      method: 'post',
      params: data
    });
  },
  //获取套餐详情
  tcInvoiceJk (data) {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/tcInvoiceJk',
      method: 'post',
      params: data
    });
  },
  //获取套餐详情
  tcInvoiceNotTime (data) {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/tcInvoiceNotTime',
      method: 'post',
      params: data
    });
  },

  //获取套餐详情
  packageInvoiceKaiPiao (data) {
    return http({
      url: '/api/swyl/v1/demo/orderNxKaipiao/packageInvoiceKaiPiao',
      method: 'post',
      params: data
    });
  },
  selectTcPage (data) {
    return http({
      url: '/api/swyl/v1/dingdmainTc/selectPage',
      method: 'post',
      params: data
    })
  },
  //获取用户单位信息
  getCompanyInfo (name) {
    return http({
      url: '/api/swyl/v1/basic/bscAddrData/selectByName?name=' + name,
      method: 'post',
    });
  },
  /*getCompanyInfo(query) {
      return request({
          url: '/api/swyl/v1/basic/bscAddrData/selectByName',
          method: 'post',
          params: query
      });
  },*/
  checkIsZhidan (agentCode) {
    return http({
      url: '/api/swyl/v1/agent/bscUserInfoAgent/checkIsZhidan?agentCode=' + agentCode,
      method: 'post',
    });
  },
  selectHlmToCPage (data) {
    return http({
      url: '/api/swyl/v1/dingdhlmtoc/selectPage',
      method: 'post',
      params: data
    })
  },
  setNobilltag (id) {
    return http({
      url: '/api/swyl/v1/dingdhlmtoc/setNobilltag?id=' + id,
      method: 'post',

    })
  },
  nobilltagBatch (ids) {
    return http({
      url: '/api/swyl/v1/dingdhlmtoc/nobilltagBatch?ids=' + ids,
      method: 'post',

    })
  },
  //保存，或者提交
  commitContainer (data) {
    return http({
      url: '/api/swyl/v1/dingdmain/commitContainer',
      method: 'post',
      data: data
    });
  },
  //根据经销商编码和渠道编码获取漏斗信息
  selectByAgent (data) {
    return http({
      url: '/api/swyl/v1/loudnew/loudMain/selectByAgentPage',
      method: 'post',
      params: data
    })
  },
  selectByAgentnew (data) {
    return http({
      url: '/api/swyl/v1/loudnew/loudMain/selectByAgentnewPage',
      method: 'post',
      params: data
    })
  },
  //根据漏斗信息获取对应产品
  selectNxnewWl (data) {
    return http({
      url: '/api/select/wuliaonew/selectPage',
      method: 'post',
      data: data
    })
  },
  //根据漏斗信息获取对应产品
  selectPageByLoud (data) {
    return http({
      url: '/api/select/wuliaonew/selectPageByLoud',
      method: 'post',
      data: data
    })
  },
  //根据漏斗信息获取对应产品
  getPackageByLoud (data) {
    return http({
      url: '/api/select/wuliaonew/getPackageByLoud',
      method: 'post',
      params: data
    })
  },
  //根据漏斗信息获取对应产品
  getChannelByAreaLoud (data) {
    return http({
      url: '/api/select/wuliaonew/getChannelByAreaLoud',
      method: 'post',
      params: data
    })
  },
  //订单号根据产地分组
  groupByFactory (f) {
    return http({
      url: '/api/swyl/v1/dingdmain/groupByFactory',
      method: 'post',
      params: f
    })
  },
  //设备公司退税发票列表查询
  seletTuishuiInvoicePage (data) {
    return http({
      url: '/api/swyl/v1/tuishuiInvoice/selectPage',
      method: 'post',
      params: data
    })
  },
  //获取汇率
  getYcExchange (param) {
    return http({
      url: '/api/swyl/v1/demo/bscForecastForeDetail/getYcExchange',
      method: 'post',
      params: param
    });
  },

  //订单根据区域获取渠道
  getChannelByArea (param) {
    return http({
      url: '/api/select/wuliao/getChannelByArea',
      method: 'post',
      params: param
    });
  },

  // 查询四张产品比对视图
  getAreaCode (query) {
    return http({
      url: '/api/swyl/v1/demo/viewOrderFourview/getAreaCode?areaName=' + query,
      method: 'post',
    });
  },

  //订单根据区域获取渠道
  getInvoiceObtain (number) {
    return http({
      url: '/api/swyl/v1/viewOrderProcess/getInvoiceObtain?number=' + number,
      method: 'post',
    });
  },
  //元析订单下载发票
  getInvoiceObtainYx (number, contractId) {
    return http({
      url: '/api/swyl/v1/viewOrderProcess/getInvoiceObtainYx?number=' + number + '&contractId=' + contractId,
      method: 'post',
    });
  },
  //订单根据区域获取渠道
  getSapCodeTh (sapcode, productId) {
    return http({
      url: '/api/swyl/v1/dingdmain/getSapCodeTh?sapCode=' + sapcode + "&productId=" + productId,
      method: 'post',
    });
  },
  // 采购订单-发票校验状态-手动触发
  checkInvoiceStatusManual(data) {
    return http({
      url: '/api/swyl/v1/demo/bscSrmPayment/checkInvoiceStatusManual',
      method: 'post',
      data: data
    });
  }
}

